import { VFC } from 'react'
import { asModal } from 'src/components/hoc/asModal'
import { LoginUser } from 'src/models/User'
import { truewhite, _profileoverlay } from 'src/styles/colors'
import styled, { css } from 'styled-components'

export type MessageCountModalViewProps = {
  user: LoginUser
}

const MessageCountModalView: VFC<MessageCountModalViewProps> = () => {
  return (
    <Layout>
      <MessageCountModalMessage>
        残りメッセージ送信可能社数が0回になりました。
      </MessageCountModalMessage>
      <MessageCountModalMessage>
        送信可能数は毎月1日にリセットされます。
      </MessageCountModalMessage>
    </Layout>
  )
}

const modalOverlayStyle = css`
  backdrop-filter: blur(6px) brightness(0.5);
  background-color: ${_profileoverlay}80;
`

export const MessageCountModal = asModal(MessageCountModalView, {
  overlayStyle: modalOverlayStyle,
  scrollable: true,
})

const Layout = styled.div`
  width: 600px;
  height: 300px;
  max-height: 100%;
  background: ${truewhite};
  border-radius: 6px;
  padding: 30px 40px;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 640px) {
    width: 382px;
    padding: 20px 20px;
  }
`

const MessageCountModalMessage = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 10px;
`
